function e(o) {
  return e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, e(o);
}
export {
  e as default
};
